<template>
  <div id="map" style="height: 500px;"></div>
</template>

<script setup>
import { onMounted } from 'vue';
import L from 'leaflet';
import ProgramList from "@/jsonData/QuantumMastersData_FinalComplete_with_Coordinates_UTF8";

onMounted(() => {
  const map = L.map('map').setView([20, 0], 2); // Centered globally

  // Create a map of universities with their Coordinates and programs
  const UniMap = {};

  ProgramList.forEach(entry => {
    const { Country, Link, City, University, Program, Coordinates } = entry;

    if (!UniMap[University]) {
      UniMap[University] = {
        university: University,
        Coordinates: Coordinates,
        programs: [],
        link: Link,
        city: City,
        country: Country
      };
    }

    UniMap[University].programs.push(Program);
  });

  // Convert to array for iteration
  const UniList = Object.values(UniMap);

  console.log(JSON.stringify(UniList));

  // Add tile layer
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; OpenStreetMap contributors'
  }).addTo(map);

  // Add markers
  UniList.forEach(uni => {

    const popupContent = `
      <strong>${uni.university}</strong><br/>
      ${uni.city}, ${uni.country}<br/>
      Programs: ${uni.programs.join(", ")}<br/>
      <a href="${uni.link}" target="_blank">More Info</a>
    `;


    L.marker([uni.Coordinates.Latitude, uni.Coordinates.Longitude])
      .addTo(map)
      .bindPopup(popupContent);
  });
});
</script>
